import { useEffect, useRef } from "react";
import { COMPOSER_SAVED_EVENT } from "../utils/composerSaveEvents";
export default function useComposerSaved(childId, onSaved) {
  const callback = useRef(onSaved);
  callback.current = onSaved;
  useEffect(() => {
    const handle = (event) => {
      if (childId && event.detail?.childId === childId) callback.current?.();
    };
    window.addEventListener(COMPOSER_SAVED_EVENT, handle);
    return () => window.removeEventListener(COMPOSER_SAVED_EVENT, handle);
  }, [childId]);
}
